import React, { forwardRef } from 'react'
import { Rnd } from 'react-rnd'
import { Box, IconButton } from '@mui/material'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import RotateRightIcon from '@mui/icons-material/RotateRight'

/**
 * collageItems = [
 *   {
 *     imageUrl: string,
 *     x: number,
 *     y: number,
 *     width: number,
 *     height: number,
 *     rotation: number
 *   }
 * ]
 *
 * setCollageItems: function => kolaj ögelerini günceller
 * 
 * Bileşeni html2canvas ile "DOM" olarak yakalamak için
 * parent’tan gelen ref'i en dış <Box> elementine vereceğiz.
 */
const CollageCanvas = forwardRef(function CollageCanvas({ collageItems, setCollageItems }, ref) {
  // Döndürme butonları
  const handleRotate = (index, delta) => {
    setCollageItems((prev) => {
      const newArr = [...prev]
      const currentRotation = newArr[index].rotation || 0
      newArr[index].rotation = currentRotation + delta
      return newArr
    })
  }

  // Sürükleme bitince pozisyon güncelle
  const handleDragStop = (index, d) => {
    setCollageItems((prev) => {
      const newArr = [...prev]
      newArr[index].x = d.x
      newArr[index].y = d.y
      return newArr
    })
  }

  // Yeniden boyutlandırma bitince ölçüler + konum güncelle
  const handleResizeStop = (index, refEl, position) => {
    setCollageItems((prev) => {
      const newArr = [...prev]
      newArr[index].width = parseFloat(refEl.style.width)
      newArr[index].height = parseFloat(refEl.style.height)
      newArr[index].x = position.x
      newArr[index].y = position.y
      return newArr
    })
  }

  return (
    <Box
      ref={ref} 
      sx={{
        width: '100%',
        height: 400, // Kolaj alanı yüksekliği
        border: '1px solid #ccc',
        borderRadius: 1,
        backgroundColor: '#f9f9f9',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {collageItems.map((item, idx) => (
        <Rnd
          key={idx}
          position={{ x: item.x, y: item.y }}
          size={{
            width: item.width || 100,
            height: item.height || 100
          }}
          onDragStop={(e, d) => handleDragStop(idx, d)}
          onResizeStop={(e, direction, refEl, delta, position) =>
            handleResizeStop(idx, refEl, position)
          }
          bounds="parent"
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              backgroundImage: `url(${item.imageUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              border: '1px solid #999',
              position: 'relative',
              transform: `rotate(${item.rotation || 0}deg)`,
              transformOrigin: 'center center'
            }}
          >
            {/* Döndürme butonları (isteğe bağlı) */}
            <IconButton
              size="small"
              onClick={() => handleRotate(idx, -15)}
              sx={{ position: 'absolute', top: 0, left: 0, color: 'white' }}
            >
              <RotateLeftIcon fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => handleRotate(idx, 15)}
              sx={{ position: 'absolute', top: 0, right: 0, color: 'white' }}
            >
              <RotateRightIcon fontSize="small" />
            </IconButton>
          </Box>
        </Rnd>
      ))}
    </Box>
  )
})

export default CollageCanvas